module.exports = __webpack_public_path__ + "img/Math & Quantitative Science.ce15ea5b.jpg";